import { render } from "./PlacePage.vue?vue&type=template&id=87f7e98c"
import script from "./PlacePage.vue?vue&type=script&lang=js"
export * from "./PlacePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__